import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import { memo } from 'react'

const Overline = ({
  children,
  className,
  as = 'div'
}: {
  children: React.ReactNode
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div'
}) => (
  <Base
    as={as}
    className={cn('textstyle-md-regular text-neutral-400', className)}
  >
    {children}
  </Base>
)

export default memo(Overline)
